import { createGlobalStyle } from 'styled-components';

export const VideoNotesEditorStyle = createGlobalStyle`
  .notes-editor {
    .DraftEditor-root {
      max-width: 100%;
      border: 0;
      background: ${({ theme }) => theme.colors.black20};
      border-radius: 4px;
      outline: none;
      padding: 10px;
      height: 300px;
      transition: height 0.15s ease-out;
      color: ${({ theme }) => theme.colors.color100};
      ${({ theme }) => theme.fontTypes.type1}
      overflow-y: scroll;
      &::-webkit-scrollbar {
        display: none;
      }

      border-radius: 4px;

      &.focused {
        height: 300px;
      }
    }

    div.DraftEditor-editorContainer,
    div.public-DraftEditor-content {
      height: 100%;
    }

    &.focused {
      .DraftEditor-root {
        background: ${({ theme }) => theme.colors.black50};
    }
    }
  }
`;
